const routers = [
  {
    // 数据字典
    path: '/dictionary/list',
    name: 'dictionary',
    component: () => import('@/views/modules/base/dictionary/List.vue')
  },
  {
    // 物料
    path: '/baseMaterial/list',
    name: 'baseMaterial',
    component: () => import('@/views/modules/base/baseMaterial/List.vue')
  }
]
export default routers
